import React, { useState, useEffect } from 'react';
import styles from './Table.module.css'; // 원하는 스타일 적용
import dayjs from 'dayjs';
import { ko } from "date-fns/locale/ko";
import DatePicker from "react-datepicker";
import { TableStateType } from '../../../utils/contextapi/TableProvider';

export const ADMINROLE = {
  SYS_ADMIN: 'SYS_ADMIN',
  ADMIN_USER: 'ADMIN_USER'
}

const AuditTable = ({ 
  datas, context, detailAudit, onPrevPage, onNextPage, 
  disablePrev, disableNext, pageNumber, totalCount, listSize, isMobileWindow, 
  serviceList, selectedServiceId, onServiceChange,
  selectedMainCode, onMainCodeChange,
  selectedSubCode, onSubCodeChange,
  sortModel, onSortChange
  }) => {

  // 정렬 처리
  const handleSort = (field) => {
    const isAsc = sortModel.field === field && sortModel.sort === 'asc';
    onSortChange({
        field: field,
        sort: isAsc ? 'desc' : 'asc'
    });
  };

  // const sortedDatas = [...datas].sort((a, b) => {
  //   let valA = a[sortField];
  //   let valB = b[sortField];
  //   // 날짜 비교
  //   if (sortField === "createdDate" || sortField === "lastConnectionDate") {
  //     valA = Number(valA) || 0;
  //     valB = Number(valB) || 0;
  //   }
  //   if (valA < valB) return sortOrder === "asc" ? -1 : 1;
  //   if (valA > valB) return sortOrder === "asc" ? 1 : -1;
  //   return 0;
  // });

  const dateView = (dateView) => { 
    const date = new Date(dateView);
    return dayjs(date).format('YYYY-MM-DD hh:mm:ss');
  };

  return (
    <div className={styles.tableSection}>
      <div className={styles.actionTopBar}>
        {/* 왼쪽: 검색 */}
        <div className={styles.actionBar}>
          <select
              className={styles.rightCont__cont__select}
              value={selectedServiceId}
              onChange={onServiceChange}
          >
              <option value="">{isMobileWindow ? "서비스" : "서비스 선택"}</option>
              {serviceList.map(service => (
                  <option key={service.serviceId} value={service.serviceId}>
                      {service.serviceName}
                  </option>
              ))}
          </select>
          <div className={styles.rightCont__cont__calenderWrap}>
              <DatePicker
              className={styles.rightCont__cont__calender}
              locale={ko}
              selectsRange={true}
              startDate={context.state.dateRange[0]}
              endDate={context.state.dateRange[1]}
              onChange={(update) => {
                  context.actions.contextDispatch({type: TableStateType.DATE_RANGE, data: update});
              }}
              withPortal={true}
              />
          </div>
          <select className={styles.rightCont__cont__select} value={selectedMainCode} onChange={onMainCodeChange}>
              <option value={""}>{isMobileWindow  ? "분류" : "분류 선택"}</option>
              {context.state.mainCode && typeof context.state.mainCode === 'object' && Object.entries(context.state.mainCode).map((item) => (
                  <option value={item[0]} key={item[0]}>{item[1]}</option>
              ))}
          </select>
          {/* <select className={styles.rightCont__cont__select} value={selectedSubCode} onChange={onSubCodeChange}>
              <option value={""}>{isMobileWindow  ? "분류" : "분류 선택"}</option>
              {context.state.subCode && typeof context.state.subCode === 'object' && Object.entries(context.state.subCode).map((item) => (
                  <option value={item[0]} key={item[0]}>{item[1]}</option>
              ))}
          </select> */}
          {/* <button
            onClick={() => onSearch()}
            className={styles.addBtn}
          >
            검  색
          </button> */}
        </div>
          <>
            {/* 오른쪽: 버튼 묶음 */}

          </>
      </div>
      <table className={styles.table}>
        <thead>
          <tr>
            <th className={styles.idCol} onClick={() => handleSort('mainTypeView')} style={{ cursor: 'pointer' }}>
              분류 {sortModel.field === 'mainTypeView' ? (sortModel.sort === 'asc' ? '▲' : '▼') : ''}
            </th>
            {!isMobileWindow &&
              <th className={styles.idCol} onClick={() => handleSort('unifiedProfileId')} style={{ cursor: 'pointer' }}>
                내용 {sortModel.field === 'detail' ? (sortModel.sort === 'asc' ? '▲' : '▼') : ''}
              </th>
            }
            <th className={styles.idCol} onClick={() => handleSort('createdDate')} style={{ cursor: 'pointer' }}>
              등록일 {sortModel.field === 'createdDate' ? (sortModel.sort === 'asc' ? '▲' : '▼') : ''}
            </th>
          </tr>
        </thead>
        <tbody>
          {datas.map((data) => (
            <tr key={data.auditId} className={styles.tableRow} onClick={() => detailAudit(data)} style={{ cursor: "pointer" }}>
              <td className={styles.idCol}>{data.mainTypeView}</td>
              {!isMobileWindow &&
                <td className={styles.idCol}>{data.detail}</td>
              }
              <td className={styles.idCol}>{dateView(data.createdDateView)}</td>
            </tr>
          ))}
          {datas.length === 0 && (
            <tr>
              {!isMobileWindow ?
                (<td colSpan={3} style={{ textAlign: "center", color: "#888" }}>{selectedServiceId === '' ? '서비스를 선택해주세요.' : '운영 로그가 없습니다.'}</td>) :
                (<td colSpan={2} style={{ textAlign: "center", color: "#888" }}>{selectedServiceId === '' ? '서비스를 선택해주세요.' : '운영 로그가 없습니다.'}</td>)
              }
            </tr>
          )}
        </tbody>
      </table>
      <div className={styles.actionBarBottom} style={{ marginTop: "8px" }}>
        <>
          {totalCount > 0 && (
            <p className={styles.text} >{pageNumber * listSize + 1} - {Math.min((pageNumber * listSize + 1) + listSize - 1, totalCount)} of {totalCount} </p>
          )}
          <button className={styles.addBtn} onClick={onPrevPage} disabled={disablePrev}>{"<"}</button>
          <button className={styles.addBtn} onClick={onNextPage} disabled={disableNext}>{">"}</button>
        </>
      </div>
    </div>
  );
};

export default AuditTable;
